module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/411.3d2ed95d.png";